var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading)?_c('b-loading',{attrs:{"active":true}}):(_vm.isMaintenance)?_c('MaintenanceView'):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }